import React, { useContext } from 'react';
import classNames from 'classnames';
import { PaginationPropTypes } from '../../../types';
import { MAX_INDEX } from '../../../utils/constants';
import { AppContext } from '../../context/listingsContext';
import { renderPageNumbers, pageUrl } from './utils';
import './style.scss';

const Pagination = ({ pagination }) => {

    /**
     * Calculate what pages pagination to show
     * @param { number } page - the current page we are on
     */

    const { isTouch } = useContext(AppContext);

    const { page, page_size, total, offset }  = pagination;

    const totalPages = Math.ceil(total / page_size);
    const numberOfPages = Math.min(MAX_INDEX, totalPages);

    const hideLeftArrow = page === 1,
        hideRightArrow = page === numberOfPages || total === 0;

    const ulClassNames = classNames('page-pagination', { 'desktop': !isTouch });
    const arrowsClassNames = classNames('pagination-arrows', { 'is-touch': isTouch });
    const leftArrowClasses = classNames(arrowsClassNames, { 'hide-arrow': hideLeftArrow });
    const rightArrowClasses = classNames(arrowsClassNames, { 'hide-arrow': hideRightArrow });

    const nextUrl = pageUrl(page + 1, offset);
    const prevUrl = pageUrl(page - 1, offset);
    const firstPageUrl = pageUrl(1, offset);

    return (
        <ul id="pagination" className={ulClassNames}>
            {isTouch && <li className={`${arrowsClassNames} arrow-first-page`}>{page > 2 && <a href={firstPageUrl}><i className="fa fa-angle-double-left"/></a>}</li>}
            <li className={leftArrowClasses}>{!hideLeftArrow && <a href={prevUrl}><i className="fa fa-chevron-left"/></a>}</li>
            {renderPageNumbers(page, numberOfPages, offset, isTouch)}
            <li className={rightArrowClasses}>{!hideRightArrow && <a href={nextUrl}><i className="fa fa-chevron-right"/></a>}</li>
        </ul>
    );
};

Pagination.propTypes = PaginationPropTypes;

export default Pagination;
